import React from 'react'
import { render } from 'react-dom'
import { Component } from 'react'
import PropTypes from 'prop-types';

class PlayButton extends Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    return (
    <a
      href="#"
      className="btn btn-green"
      id="button"
      style={{display: (this.props.visible ? 'block' : 'none')}}
      onClick={(e) => {
        e.preventDefault()
        this.props.onClick;
      }}
      >
      {this.props.text}
    </a>
    )
    // return (
    // <a
    //   href="#"
    //   className="btn btn-green"
    //   id="button"
    //   style={{display: (this.props.visible ? 'block' : 'none')}}
    //   onClick={(e) => {
    //     e.preventDefault()
    //     this.props.onClicked();
    //   }}>
    //   {this.props.text}
    // </a>
    // )
  }
}

// PlayButton.propTypes = {
//   visible: PropTypes.bool.isRequired,
//   onClicked: PropTypes.func.isRequired,
// };

export default PlayButton;


// WEBPACK FOOTER //
// ./src/app/components/PlayButton.js